module.exports = __webpack_public_path__ + "img/company_logo2.18c16aec.jpg";